export const PENDING_PROMOTION_KEY = "aorra:pending-promotion";
export const PROMOTION_AUTOFILL_MS = 24 * 60 * 60 * 1000;

export function rememberPromotion(code) {
  localStorage.setItem(PENDING_PROMOTION_KEY, JSON.stringify({ code, at: Date.now() }));
}

export function pendingPromotion() {
  try {
    const value = JSON.parse(localStorage.getItem(PENDING_PROMOTION_KEY));
    if (value?.code && Number.isFinite(value.at) && value.at <= Date.now() && Date.now() - value.at < PROMOTION_AUTOFILL_MS) return value.code;
  } catch (_) { /* Ignore invalid browser storage. */ }
  localStorage.removeItem(PENDING_PROMOTION_KEY);
  return null;
}

export function savedPromotion(userId) {
  const key = `aorra:claimed-promotion:${userId}`;
  try {
    const value = JSON.parse(sessionStorage.getItem(key));
    if (value?.code && Number.isFinite(value.expiresAt) && value.expiresAt > Date.now()) return value;
  } catch (_) { /* Old plain codes have no expiry and must not persist. */ }
  sessionStorage.removeItem(key);
  return null;
}

export function rememberClaimedPromotion(userId, code, expiresAt) {
  const parsed = expiresAt ? new Date(expiresAt).getTime() : NaN;
  const expiry = Number.isFinite(parsed) ? parsed : Date.now() + PROMOTION_AUTOFILL_MS;
  sessionStorage.setItem(`aorra:claimed-promotion:${userId}`, JSON.stringify({ code, expiresAt: expiry }));
  return expiry;
}

export function forgetPromotion(userId) {
  localStorage.removeItem(PENDING_PROMOTION_KEY);
  sessionStorage.removeItem(`aorra:claimed-promotion:${userId}`);
}

export function referralOffer(data) {
  const rules = data?.rules;
  if (!rules) return { title: "Invita a un amigo", lines: [] };
  const p = data.profile || {};
  const recovery = data.offer_mode === "recovery";
  const target = (type) => type === "last" ? p.last_lost_streak : p.longest_streak;
  const lines = [];
  if (recovery) {
    if (rules.activity_enabled && target(rules.activity_reward) > p.current_streak) lines.push(`Recupera ${target(rules.activity_reward)} días cuando tu amigo registre ${rules.expense_count} ${rules.expense_count === 1 ? "gasto" : "gastos"}. No necesita pagar.`);
    if (rules.purchase_enabled && target(rules.purchase_reward) > p.current_streak) lines.push(`Si compra una suscripción elegible, recuperas ${target(rules.purchase_reward)} días.`);
  } else if (rules.bonus_enabled) {
    const condition = rules.bonus_event === "purchase" ? "compren una suscripción elegible" : `registren ${rules.bonus_expense_count} ${rules.bonus_expense_count === 1 ? "gasto" : "gastos"} cada uno`;
    lines.push(`Gana ${rules.bonus_days} días extra ${rules.bonus_repeat ? "por cada" : "al invitar a"} ${rules.bonus_friends} ${rules.bonus_friends === 1 ? "amigo que" : "amigos que"} ${condition}.`);
  }
  return { title: !lines.length ? "Invita a un amigo" : recovery ? "Recupera tu racha" : "Invita y suma días", lines,
    detail: !lines.length ? "" : recovery ? "Los días de ausencia no se suman." : `Hasta ${rules.bonus_monthly_days} días extra al mes.`, recovery };
}
